/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSoundDetectionDogBarkingIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sound-detection-dog-barking"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.53 22.32L4.53 15.35L9.78 20.6Q11.22 19.15 12.4 17.49Q13.57 15.82 13.57 13.8Q13.57 12.32 13.01 10.99Q12.45 9.65 11.4 8.6L8.47 5.67L8.47 5.67L11.72 5.67L15.85 1.55L18.13 3.83Q19.18 4.88 19.73 6.2Q20.27 7.53 20.27 9Q20.27 10.47 19.73 11.8Q19.18 13.13 18.13 14.18L16.18 16.13L16.18 22.32ZM9.78 17.77L4.35 12.35Q4.03 12.03 3.85 11.6Q3.67 11.18 3.67 10.72Q3.67 10.25 3.85 9.82Q4.03 9.4 4.35 9.07L6.67 6.72L10 10.03Q10.75 10.78 11.16 11.75Q11.57 12.72 11.57 13.8Q11.57 14.93 11.07 15.95Q10.57 16.98 9.78 17.77Z" fill={color} />
    </svg>
  );
}
